import { h } from 'preact';
import { t } from '../../i18n.js';

export default function StatusBadge({ status, type = 'process' }) {
  const ns = type === 'step' ? 'process.stepStatuses' : type === 'task' ? 'task.statuses' : 'process.statuses';
  const label = t(`${ns}.${status}`) || status;

  return (
    <span class={`badge badge-${status}`}>
      <span class="badge-dot" />
      {label}
    </span>
  );
}
